module.exports = __webpack_public_path__ + "img/kbstar_visual.7cce5785.jpg";